// Description: Component that will render the content that will be displayed in the modal
// Updated: 15/07/2025
// Author: Simon Franklin

// React
import React from 'react';

// Material UI Components
import { Box, CircularProgress } from '@mui/material';

// Components and functions to the project
import ModeGraphicModalFilter from './ModeGraphicModalFilter';
import ExcelTable from './ExcelTable';
import { DynamicTable } from './IndicatorsList';

// Render the component
const ModeGraphicModalContent = ({
  setEndDate,
  startDate,
  endDate,
  setStartDate,
  downloadExcel,
  loadingExcel,
  loadingLabels,
  searchCampaigns,
  loadingSearch,
  setValueSearch,
  valueSearch,
  filteredCampaigns,
  setFilteredCampaigns,
  fetchDataToNewTable,
  loadingTable,
  showNewTable,
  excelColumns,
  setExcelColumns,
  rows,
  setRows,
  columns,
  campaigns,
  loading,
  page,
  setPage,
  rowsPerPage,
  totalItems,
  themeColors,
  sentMessagesLength,
  setSentMessagesLength,
  totalApiPages,
  setTotalApiPages
}) => {
  return (
    <Box
      component="div"
      sx={{
        minHeight: '100%',
        minWidth: '100%',
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'start',
        overflow: 'auto',
        padding: '0px',
      }}
    >
      {showNewTable && loadingTable === false ? null : (
        <ModeGraphicModalFilter
          setEndDate={setEndDate}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          downloadExcel={downloadExcel}
          loadingExcel={loadingExcel}
          loadingLabels={loadingLabels}
          searchCampaigns={searchCampaigns}
          loadingSearch={loadingSearch}
          setValueSearch={setValueSearch}
          valueSearch={valueSearch}
          campaigns={[]}
          filteredCampaigns={filteredCampaigns}
          setFilteredCampaigns={setFilteredCampaigns}
          fetchDataToNewTable={fetchDataToNewTable}
          loadingTable={loadingTable}
        />
      )}

      {showNewTable ? (
        loadingTable ? (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress style={{ color: themeColors.purple500 }} />
          </Box>
        ) : (
          <ExcelTable
            columns={excelColumns}
            setColumns={setExcelColumns}
            endDate={endDate}
            rows={rows}
            setRows={setRows}
            startDate={startDate}
            sentMessagesLength={sentMessagesLength}
            setSentMessagesLength={setSentMessagesLength}
            totalApiPages={totalApiPages}
            setTotalApiPages={setTotalApiPages}
          />
        )
      ) : (
        <DynamicTable
          columns={columns}
          data={campaigns}
          handlePageChange={(event, newPage) => setPage(newPage)}
          loading={loading}
          page={page}
          rowsPerPage={rowsPerPage}
          totalItems={totalItems}
          selectedLabel={''}
        />
      )}
    </Box>
  );
};

export default ModeGraphicModalContent;